export default __webpack_public_path__ + "media/images/front/about/explanation-18a8783691f476234a4878b476c71922.png";